// extracted by mini-css-extract-plugin
export default {"container":"NZ-z","heading":"OZ-z","links":"PZ-z","copy":"QZ-z","subCopy":"RZ-z","linksLeft":"SZ-z","linksCenter":"TZ-z","linksRight":"UZ-z","link":"VZ-z","onlyLink":"WZ-z"};